export default {
    existAlert: state => (alertName) => {
        return state.alerts[alertName] !== undefined;
    },
    getAlert: state => (alertName) => {
        return state.alerts[alertName];
    },
    getAlerts: state => state.alerts,
    hasErrorAlerts: state => Object.keys(state.alerts).find(key => state.alerts[key].type === 'error') !== undefined,
};
